import { useState, createContext, useContext, useEffect, useCallback, useMemo } from "react";
import UploadFileDialog from "../UploadFileDialog";
import { isImage, isVideo, uuid } from "utils";

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
  isShowUploadDialog: false,
  setFileType: _fileType => {},
  resetData: () => {},
  uploadFiles: _fileList => {},
};
export const UPLOAD_FILE_TYPE = {
  media: "image-video", // Image/ video
  file: "other-file", // other
};
const UploadFileContext = createContext(INITIAL_STATE);
export const useUploadFileContext = () => {
  const context = useContext(UploadFileContext);
  if (!context) throw new Error("useUploadFileContext must be used within UploadFileProvider");
  return context;
};

export const UploadFileProvider = ({ children }) => {
  const [fileType, setFileType] = useState(null);
  const [files, setFiles] = useState([]);

  const resetData = useCallback(() => {
    setFileType(null);
    setFiles([]);
  }, []);

  const uploadFiles = useCallback(fileList => {
    const multipleFile = [];
    for (let index = 0; index < fileList?.length; index++) {
      multipleFile.push({ file: fileList[index], attachmentId: uuid() });
    }

    setFiles(multipleFile);
  }, []);

  useEffect(() => {
    // Catch event paste image
    const handlePaste = event => {
      const items = event.clipboardData || event.originalEvent.clipboardData;
      const pastedFiles = items?.files;
      const isValidFile = pastedFiles && pastedFiles.length > 0;

      if (!isValidFile) return;

      // Only image/ video file
      const isOnlyMediaFiles =
        Array.from(pastedFiles).filter(item => isImage(item.type) || isVideo(item.type)).length === pastedFiles.length;

      setFileType(isOnlyMediaFiles ? UPLOAD_FILE_TYPE.media : UPLOAD_FILE_TYPE.file);
      uploadFiles(pastedFiles);
    };
    window.addEventListener("paste", handlePaste);

    return () => window.removeEventListener("paste", handlePaste);
  }, []);

  const isShowUploadDialog = useMemo(() => Array.isArray(files) && files.length > 0, [files]);
  return (
    <UploadFileContext.Provider value={{ isShowUploadDialog, resetData, uploadFiles, setFileType }}>
      {children}

      {isShowUploadDialog && (
        <UploadFileDialog isMediaType={fileType === UPLOAD_FILE_TYPE.media} multipleFile={files} onClose={resetData} />
      )}
    </UploadFileContext.Provider>
  );
};
